module.exports = "ul > li  {\n    display: inline-block;\n    padding: 3px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagination/pagination.component.css
// module id = ./src/app/pagination/pagination.component.css
// module chunks = main